import { render, staticRenderFns } from "./TabsLanguageSwitcher.vue?vue&type=template&id=5bffdc34&"
import script from "./TabsLanguageSwitcher.vue?vue&type=script&lang=ts&"
export * from "./TabsLanguageSwitcher.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports